
import React from 'react';
import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { formatCurrency } from '@/utils/formatters';

interface InvoicePreviewProps {
  targetPlanName: string;
  billingCycle: string;
  newAmount: number;
  prorationAmount: number;
  remainingDays: number;
  currentPlanName: string;
  finalAmount: number;
}

const InvoicePreview: React.FC<InvoicePreviewProps> = ({
  targetPlanName,
  billingCycle,
  newAmount,
  prorationAmount,
  remainingDays,
  currentPlanName,
  finalAmount
}) => {
  return (
    <Card className="p-4 border-blue-100 shadow-md">
      <h3 className="font-semibold text-lg mb-4 text-blue-800">Invoice Preview</h3>
      
      <div className="space-y-3 mb-4">
        <div className="flex justify-between">
          <span>{targetPlanName} Plan ({billingCycle})</span>
          <span className="font-medium">${formatCurrency(newAmount)}</span>
        </div>
        
        {prorationAmount > 0 && (
          <div className="flex justify-between text-green-600">
            <span>Credit for {remainingDays} days of {currentPlanName}</span>
            <span>-${formatCurrency(prorationAmount)}</span>
          </div>
        )}
      </div>
      
      <Separator className="my-4" />
      
      <div className="flex justify-between font-semibold text-lg">
        <span>Total Due Today</span>
        <span className="text-blue-700">${formatCurrency(finalAmount)}</span>
      </div>
      
      <div className="mt-4 text-sm text-muted-foreground bg-blue-50 p-3 rounded-md">
        Your next billing date will be {billingCycle === 'monthly' ? '30 days' : billingCycle === 'quarterly' ? '90 days' : '365 days'} from today.
      </div>
    </Card>
  );
};

export default InvoicePreview;
